export default "__VITE_ASSET__BjOcpz7Y__"